import { createContext } from "react";

const DropDownContext = createContext();

export default DropDownContext;
